module.exports = __webpack_public_path__ + "static/media/canal_logitech.01b2a1bc.jpg";